import Button from "../../../components/Button";
import Container from "../../../components/Container";
import {
  ImpactContent,
  ImpactDescription,
  ImpactSection,
  ImpactTitle,
} from "./style";

type InspectionProps = SectionsProps & {
  topRef?: React.MutableRefObject<any>;
};

export default function ImpactionSection({
  topRef,
  referance,
}: InspectionProps) {
  const buttonWidth = window.innerWidth > 1366 ? "65%" : "80%";
  return (
    <ImpactSection ref={topRef}>
      <Container>
        <ImpactContent>
          <ImpactTitle>
            Transforme sua Empresa com Soluções Tecnológicas de Ponta
          </ImpactTitle>
          <ImpactDescription>
            Somos referência em suporte técnico personalizado, desenvolvimento
            sob medida e consultoria tecnológica.
          </ImpactDescription>
          <Button
            title="solicite uma consulta gratuita"
            click={() =>
              referance?.current.scrollIntoView({
                behavior: "smooth",
              })
            }
            width={buttonWidth}
          />
        </ImpactContent>
      </Container>
    </ImpactSection>
  );
}
